/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import {
  INTRADAY,
  POSITIONAL_TYPE_N_DAYS,
  POSITIONAL_TYPE_NEXT_DAY,
} from '@quantiply/common/constants';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    textTransform: 'capitalize',
  },
}));

export const tradeTypeOptions = [
  {
    value: INTRADAY,
    label: 'Intraday',
  },
  {
    value: POSITIONAL_TYPE_NEXT_DAY,
    label: 'STBT/BTST',
  },
  {
    value: POSITIONAL_TYPE_N_DAYS,
    label: '(N) days before expiry',
    simpleLabel: 'n days before expiry',
  },
];

const CellTradeType = ({ row = {} }) => {
  const history = useHistory();
  const classes = useStyles();
  const { original = {} } = row;
  const { _id = '', tradingType = '' } = original;
  const formattedLabel =
    tradeTypeOptions.find((item) => item.value === tradingType)?.label || '';

  const handleRedirectToAlgoEdit = () => {
    history.push(`/algos/${_id}`, {
      from: window.location.hash,
    });
  };

  return (
    <div className={classes.root} onClick={handleRedirectToAlgoEdit}>
      {formattedLabel}
    </div>
  );
};

export default CellTradeType;
